export default __webpack_public_path__ + "static/media/features.1.7a9d4cd6.svg";